module.exports = __webpack_public_path__ + "assets/0103_IFOK_WIM_MARKER_blue_group_je.43cbf12e.svg";